<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <h2 class="subtitle subtitle-{{status}}">CONSULTA {{i+1}}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">AGENCIA</span>
                        <span class="text-uppercase">{{ r.agencia || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">BANCO</span>
                        <span class="text-uppercase">{{ r.banco || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CIDADE</span>
                        <span class="text-uppercase">{{ r.cidade || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">UF</span>
                        <span class="text-uppercase">{{ r.uf || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">DATA</span>
                        <span class="text-uppercase">{{ r.data_ultimo_cheque || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">MOTIVO</span>
                        <span class="text-uppercase">{{ r.motivo || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ORIGEM</span>
                        <span class="text-uppercase">{{ r.origem || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">QUANTIDADE</span>
                        <span class="text-uppercase">{{ r.quantidade || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
    </ng-container>

</app-card-consulta>